import $ from 'jquery';
import mask from 'jquery-mask-plugin';

function scrollToTop() {
	const scrollTop = $('.scroll-top');
	if (scrollTop.length) {
		$(window).on('scroll', function (){
			if ($(this).scrollTop() > 200) {
				scrollTop.fadeIn();
			}else {
				scrollTop.fadeOut();
			}
		});

		scrollTop.on('click', function (){
			$('html, body').animate({scrollTop: 0}, 1200);
			return false;
		});
	}
}

function formHandler(selector) {
	return $(document).on('submit', selector, function (e){
		e.preventDefault();
		const that = $(this);
		const url = that.attr('action');
		const data = that.serialize();
		const agree = that.find('.agree__block input[type=checkbox]');
		if (!(agree.length && !agree.prop('checked'))) {
			$.ajax({
				type: 'POST',
				dataType: 'json',
				url,
				data,
				success: function (response) {
					return that.find('.success__box').html(response.message).fadeIn().delay(5000).fadeOut() && that.trigger('reset');
				}
			});
		}else {
			agree.closest('.agree__block').find('.error').fadeIn().delay(3000).fadeOut();
		}
	});
}
$(() => {
	$('form .phone').mask('+0 (000) 000-00-00', {placeholder: '+_ (___) ___-__-__'});

	const offset = $('.form__box').offset();
	$('.why__we').on('click', '.btn__call', () => {
		const sclTop = parseInt(offset.top - 20);
		return $('html, body').animate({scrollTop: sclTop}, 'slow');
	});
	scrollToTop();
	formHandler('#form_order');
});



// WEBPACK FOOTER //
// ./app/scripts/app.js